import Cookie from 'js-cookie'
import { adModel as ad } from '../../library'
// 当前正在运行的弹窗
let running = null
// 弹窗注册列表
const popups = []
// 弹窗队列
const quenePopups = []

export const register = function({ name, open, close }) {
  if (!popups.some((i) => i.name === name)) {
    popups.push({
      name,
      open,
      close
    })
  }
}
export const open = function({ name, expired, options, adModel }) {
  if (adModel) {
    register({
      name,
      open() {
        ad(adModel)
      },
      close() {}
    })
  }
  const pop = popups.find((p) => {
    return p.name === name
  })
  if (!pop) return console.error(`弹窗：${name}，未注册`)
  const fn = () => {
    // 如果弹窗未过期则什么也不触发
    function afterClose() {
      running = null
      const p = quenePopups.shift()
      p instanceof Function && p()
    }
    if (expired && isExpired(name, expired)) return afterClose()
    pop.open({
      ...options,
      afterClose
    })
  }
  // 检查队列
  if (!running) {
    running = name
    fn()
  } else {
    quenePopups.push(fn)
  }
  return pop
}

// 清除所有弹窗
export const clear = function() {
  if (running) {
    const pop = popups.find((p) => {
      return p.name === running
    })
    pop && pop.close()
  }
  quenePopups.splice(0)
}

/**
 * 判断参数日期是否是今天
 * @param {Date} date Date实例
 * @returns {Boolean} 是否是今天
 */
export const isToday = function(date) {
  const now = new Date()
  if (
    now.getFullYear() === date.getFullYear() &&
    now.getMonth() === date.getMonth() &&
    now.getDate() === date.getDate()
  ) {
    return true
  }
  return false
}

/**
 * 判断date是否在一个时间段内
 * @param {Date} date 需要判断的日期
 * @param {Date} start 开始的时间
 * @param {Date} end 结束的时间
 * @returns {Boolean} date是否在开始时间与结束时间之间
 */
export const inTheMeantime = function(date, start, end) {
  return date.getTime() >= start.getTime() && date.getTime() <= end.getTime()
}

function isExpired(name, expired) {
  // 过期情况处理
  const cookieKey = `POPUP_EXPIRED_${name}`
  const valueOfKey = Cookie.get(cookieKey)
  if (expired && valueOfKey) return true // 过期的情况下直接退出
  if (expired) {
    const now = new Date()
    const expiredDate =
      typeof expired === 'number'
        ? new Date(expiredDate)
        : new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1)
    Cookie.set(cookieKey, 1, { expires: expiredDate })
  }
  return false
}
